import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import sessionStorage from 'sessionstorage';

Vue.use(Router);
const router = new Router({
    routes: [
        {
            path: '/home',
            name: 'Home',
            component: Home
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        }

    ]
});

if (sessionStorage.getItem('user')) {
    router.replace({name: 'Home'})
} else {
    router.replace({name: 'Login'})
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js